import { decode } from "js-base64";
import { codeSamples } from "./python";

export function parseBase64(base64?: string): string {
  base64 = base64 ?? "";
  const name = decode(base64);
  return codeSamples[name] ? codeSamples[name] : codeSamples.default;
}
